export default __webpack_public_path__ + "static/media/custom2.1be032dd.jpg";